import { Component, OnInit,Input,OnChanges,ViewChild,ElementRef} from '@angular/core';
import { GridBaseCase } from "../grid.base.case";
import { Platform,IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from '../../../../service/httpcustomer.service';
import { WebParameterContext,WebResponesContext } from '../../../../model/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { CommonService } from '../../../../service/common.service';
import { MapclientServiceService } from '../../../../service/mapclient.service.service';

declare var app;
@Component({
  selector: 'app-mz-grid-list-visit',
  templateUrl: './mz-grid-list-visit.component.html',
  styleUrls: ['./mz-grid-list-visit.component.scss']
})
export class MzGridListVisitComponent extends GridBaseCase {
  dataArrayList: Array<any> = [];
  @Input() data: any;//接收父组件的值
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount:Number = 0;//列表总数量
  PageNumber:any = 1;//第一页
  locationError: boolean = false;
  locationObject:any = {};
  @ViewChild('map') map_container: ElementRef;
  constructor(
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private platform: Platform,
    private msg: MessageclientService,
    private com: CommonService,
    private map: MapclientServiceService,
  ) { super(); }
  ngOnChanges(){
   this.bindData(1);
  }
  loadMoreData(event){
    let that = this;
    if(that.RecordCount == that.dataArrayList.length){
      that.infiniteScroll.disabled = true;
    }else{
      that.PageNumber++;
      this.bindData(that.PageNumber);
    }
  }
  bindData(PageNumber) {
    
    let that = this;
    that.PageNumber = PageNumber;
    if(PageNumber == 1){
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    let startDate = that.com.getNow+" 00:00:00";
    let endDate = that.com.getNow+" 23:59:59";
    let date  = that.com.BetweenDate(startDate,endDate);
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.SpecialParameter = "ProvisionalPlan";//临时计划
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if(!that.com.GetAccount.IsAdmin){//s001表示计划拜访状态
       body.RequestBody= JSON.stringify({"a_FK_SystemUser_ID":that.com.GetAccount.Id,"a_Code":'S001',"a_VisitDate":date});
      // body.RequestBody= JSON.stringify({"a_FK_SystemUser_ID":that.com.GetAccount.Id,"a_ObjectCode":'S001'});
    }
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      
      /****判断是否第一页begin****/
      if(PageNumber == 1){
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }else{
        that.infiniteScroll.complete();
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element) => {
            if(element.bindingField){
              objfield[element.bindingField] = {"value":item[element.field],"text":element.text};
            }
          });
          that.dataArrayList.push(objfield);
          // console.log(that.element.selectItemList.selectItem);
          // console.log(that.dataArrayList);
        });
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length){
          that.infiniteScroll.disabled = true;
        }else{
          that.infiniteScroll.disabled = false;
        }
        /****上拉加载数据end****/
      }
      
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
      that.loading = true;
      //console.log(error);
    })
  }
  EventLink(ev: any, parms: any) {
    const that =this;
    let evs = ev.url || '';
    console.log(evs, parms);
    if (evs.trim() && parms) {
      if(parms["fk_store_id"]){//门店ID
        localStorage.setItem("tbstore",JSON.stringify({"ID":parms["fk_store_id"].value,"address":parms["address"].value,"name":parms["name"].value}));
      }
      // console.log("协防");
      if(parms["isvisit"].value){//临访
        localStorage.setItem("isvisit",parms["isvisit"].value);
      }else{//非临访
        localStorage.removeItem("isvisit");
      }
      if (evs.indexOf("http") > 0) {
        if(parms.title){
          this.com.goWebPage(evs,parms.title);
        }else{

        }
        // console.log(evs, parms);
      } else {
        localStorage.setItem('element', JSON.stringify(ev));
        that.bandingvisting().then((data)=>{
                if(data){
                  that.msg.Show("您还没有离店,一天不能同时进多家店");
                }else{
                  // console.log({"lng":parms.lng.value,"lat":parms.lat.value});
                  let location:any = {"lng":0,"lat":0};
                  if(parms.lng.value && parms.lat.value)
                  {
                    location = JSON.stringify({"lng":parms.lng.value,"lat":parms.lat.value});
                  }
                  localStorage.setItem("mapmun",location);
                  that.msg.Confirm("确认进店？").then(data=>{
                    if(data){
                      //入店
                      that.InStore(evs,parms);
                      // that.com.setHistoryUrl();
                      // that.router.navigateByUrl(evs +"/add/" + parms.ID.value);
                    }
                  })
                }
        },error=>{
          that.msg.Show("系统错误请联系管理员");
        });
        
      }
    }
  }
  /**
* 下拉刷新数据
* @param event
*/
  doRefresh(event) {
    this.bindData(1);
    console.log("下拉刷新");
    setTimeout(()=>{
      event.target.complete();
    },300);
  }
  bandingvisting():Promise<any>{
    let that = this;
    return new Promise<any>((resolve,reject)=>{
      const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
      let body = new WebParameterContext();
      if (that.element.selectItemList.gridViewConfigName) {
        body.ConfigName = that.element.selectItemList.gridViewConfigName;
      } 
      body.OpType = "query";
      body.ConfigType = "view";
      body.RowsPerPage = 10;
      body.SpecialParameter = "Completed";//正在拜访
      body.Client.PageName = PageName;
      body.Client.ApiType = "Element";
      body.Client.Name = that.element.name;
      body.Client.ClientType = 2;
      if(!that.com.GetAccount.IsAdmin){//S003表示拜访成功
              let startDate = that.com.getNow+" 00:00:00";
            let endDate = that.com.getNow+" 23:59:59";
            let date  = that.com.BetweenDate(startDate,endDate);
        body.RequestBody= JSON.stringify({"a_FK_SystemUser_ID":that.com.GetAccount.Id,"a_Code":'S002',"a_VisitDate":date});
        // body.RequestBody= JSON.stringify({"a_FK_SystemUser_ID":that.com.GetAccount.Id,"a_ObjectCode":'S003'});
      }
      if (that.platform.is("android")) {
        body.Client.ClientType = 0;
      } else if (that.platform.is("ios")) {
        body.Client.ClientType = 1;
      }
      that.http.post(app.DEFAULTURL, body).then(data => {
        console.log(data.ResponseMessage.Success);
        if (data.ResponseMessage.Success) {
          if(data.Status.Datas.length>0){
            resolve(true);
          }else{
            resolve(false);
          }
        }else{
          reject(data.ResponseMessage.ErrorMessage);
        }
      })
    });
    
  }

  InStore(evs,parms){
    const that = this;
    that.msg.Loading("请稍后...").then(loads=>{
      that.getLocationInfo().then(data=>{
        // debugger;
        if(data){
          let _lat = 0;
          let _lng = 0;
          let _address="";
          if(parms.lat && parms.lng){
            _lat = parms.lat.value;
            _lng = parms.lng.value;
            _address = parms.address.value;
          }
          console.log(data,"getCoordinateDifference");
          let num = that.getCoordinateDifference(_lng, _lat);
          that.locationObject.num = num;
          localStorage.setItem("nowmapdetail",JSON.stringify(that.locationObject));//存储现在地图信息
         
          if(_lat && _lng){
            // let num = that.getCoordinateDifference(_lng,_lat);
            if(num <= app.LOCATIONLENGTH){
              //定位距离异常
              const obj = {
                type:"visitIn",
                lat:that.locationObject.a_Latitude,
                lng:that.locationObject.a_Longitude,
                Address:that.locationObject.Address,
                InDeviationNumber:that.locationObject.a_InDeviationNumber || 0,
                isLocationSucess:true
              };
              localStorage.setItem("clockLocation",JSON.stringify(obj));
              localStorage.setItem("visitStoreInfo",JSON.stringify({
                id:parms.ID.value,
                name:parms.name.value,
                address:parms.address.value
              }));
              try{
                that.CloinId(0,1,that.locationObject).then(data=>{
                  console.log(data);
              }).catch(err=>{
                console.log(err);
              });
              }catch(err){
                console.log(err);
              }
              loads.dismiss(); 
              that.com.setHistoryUrl();
              that.com.Go("/tabs/contact/VisitIn/add/" + parms.ID.value+"&"+this.com.getNowDatetime);
              
            }else{
              try{
                that.CloinId(0,0,that.locationObject,0,0,"您的打卡范围超过"+app.LOCATIONLENGTH+"米").then(data=>{
                  console.log(data);
              }).catch(err=>{
                console.log(err);
              });
              }catch(err){
                console.log(err);
              }
              loads.dismiss(); 
              that.msg.Alert("您的打卡范围超过"+app.LOCATIONLENGTH+"米");
              return;
              // loads.dismiss();
              // that.com.setHistoryUrl();
              // localStorage.setItem("nowmapdetail",JSON.stringify(that.locationObject));//存储现在地图信息
              // that.router.navigate(['/mapdetail-page/'+that.com.getNowDatetime]);
            }
            // else{
            //   //保存进店数据
            //   that.InStoreApi(parms,loads);
            // }
          }else{
              //如果门店坐标不存在，并门店地址不存在则请求接口获取门店坐标 并于当前坐标比对 如超过配置得距离则不能上班。
              that.map.getGDAddressPosition(that.map_container.nativeElement,_address).then(data=>{
                _lat = data.lat||0;
                _lng = data.lng||0;
                let isSuccess = that.getlicationList(_lng,_lat,parms);
                loads.dismiss(); 
                if(isSuccess){
                  that.com.setHistoryUrl();
                  // that.router.navigateByUrl("/tabs/contact/VisitIn/add/" + parms.ID.value+"&"+this.com.getNowDatetime);
                  that.com.Go("/tabs/contact/VisitIn/add/" + parms.ID.value+"&"+this.com.getNowDatetime);
                }else{
                  that.msg.Alert("您的打卡范围超过"+app.LOCATIONLENGTH+"米");
                  // that.com.setHistoryUrl();
                  // localStorage.setItem("nowmapdetail",JSON.stringify(that.locationObject));//存储现在地图信息
                  // that.router.navigate(['/mapdetail-page/'+that.com.getNowDatetime]);
                }
               
            }).catch(err=>{
              const obj = {
                type:"visitIn",
                lat:0,
                lng:0,
                Address:null,
                InDeviationNumber:0,
                isLocationSucess:false
              };
              localStorage.setItem("clockLocation",JSON.stringify(obj));
              localStorage.setItem("visitStoreInfo",JSON.stringify({
                id:parms.ID.value,
                name:parms.name.value,
                address:parms.address.value
              }));
              try{
                that.CloinId(0,0,that.locationObject,0,0,err).then(data=>{
                  console.log(data);
              }).catch(err=>{
                console.log(err);
              });
              }catch(err){
                console.log(err);
              }
              loads.dismiss();  
              // that.com.setHistoryUrl();
              // that.router.navigateByUrl("/tabs/contact/VisitIn/add/" + parms.ID.value+"&"+this.com.getNowDatetime);
              that.msg.Alert("您的门店地址有误，请联系管理员！");
              return;
            });
          }
          
        }else{
          //定位失败-到二级页面填写信息签到
          const obj = {
            type:"visitIn",
            lat:0,
            lng:0,
            Address:null,
            InDeviationNumber:0,
            isLocationSucess:false
          };
          localStorage.setItem("clockLocation",JSON.stringify(obj));
          localStorage.setItem("visitStoreInfo",JSON.stringify({
            id:parms.ID.value,
            name:parms.name.value,
            address:parms.address.value
          }));
          try{
            that.CloinId(0,0,that.locationObject).then(data=>{
              console.log(data);
          }).catch(err=>{
            console.log(err);
          });
          }catch(err){
            console.log(err);
          }
          loads.dismiss();  
          that.com.setHistoryUrl();
          // that.router.navigateByUrl("/tabs/contact/VisitIn/add/" + parms.ID.value+"&"+this.com.getNowDatetime);
          that.com.Go("/tabs/contact/VisitIn/add/" + parms.ID.value+"&"+this.com.getNowDatetime);
          // that.msg.Alert("获取当前位置失败，请检查您的定位权限是否开启！");
          return;
        }
      }).catch(err=>{
             console.log(err,"定位异常失败");
             loads.dismiss();
            if(!app.ISGPSLOCATION){
              that.msg.Alert("请开启手机定位权限");
              return;
            }
             //定位失败-到二级页面填写信息签到
             const obj = {
              type:"visitIn",
              lat:0,
              lng:0,
              Address:null,
              InDeviationNumber:0,
              isLocationSucess:false
            };
            localStorage.setItem("clockLocation",JSON.stringify(obj));
            localStorage.setItem("visitStoreInfo",JSON.stringify({
              id:parms.ID.value,
              name:parms.name.value,
              address:parms.address.value
            }));
            try{
              that.CloinId(0,0,that.locationObject).then(data=>{
                console.log(data);
            }).catch(err=>{
              console.log(err);
            });
            }catch(err){
              console.log(err);
            }
            that.com.setHistoryUrl();
            // that.router.navigateByUrl("/tabs/contact/VisitIn/add/" + parms.ID.value+"&"+this.com.getNowDatetime);
            that.com.Go("/tabs/contact/VisitIn/add/" + parms.ID.value+"&"+this.com.getNowDatetime);
            // that.msg.Alert("获取当前位置失败，请检查您的定位权限是否开启！");
            return;
      });
      loads.present();
    })
  }

  InStoreApi(parms,loads){
    let that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.ConfigName = "TBVisitPlanConfigXML";//总表
    body.OpType = "Edite";
    body.ConfigType = "form";
    body.Client.PageName = "VisitIn";
    body.Client.ApiType = "Content";
    body.Client.Type = "add";
    body.Client.Name = "Element";
    body.Client.ClientType = 1;
    // body["Id"] = that.com.GetAccount.Id;
    body["SpecialParameter"] = "gohome";
    let _obj = {};
    //TODO:进店参数
    _obj["a_id"] = parms.ID.value;
    _obj["a_StartAddress"] = that.locationObject.Address;
    _obj["a_StartLong"] =that.locationObject.a_Longitude;
    _obj["a_StartLat"] = that.locationObject.a_Latitude;
    _obj["a_InDeviationNumber"] = that.locationObject.a_InDeviationNumber;
    _obj["a_FK_TBVisitState_ID"] = "S002";
    body.RequestBody = JSON.stringify(_obj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      loads.dismiss();
      if (data.ResponseMessage.Success) {
        this.com.setHistoryUrl();
        // this.router.navigateByUrl("/tabs/contact/VisitPlatform/add/" + parms.ID.value +"&"+this.com.getNowDatetime);
        this.com.Go("/tabs/contact/VisitPlatform/add/" + parms.ID.value +"&"+this.com.getNowDatetime);
      } else {
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }
    }).catch(error => {
      loads.dismiss();
      that.msg.Alert(app.ERRORMESSAGE);
    });
  }
  /**
   * 更新门店坐标
   * @param _lng 
   * @param _lat 
   *  @param _type 判断上班下班 
   */
  getlicationList(_lng:any,_lat:any,parms:any):boolean{
    const that=this;
    let result:boolean=false;
    let num = that.getCoordinateDifference(_lng,_lat);
    that.locationObject.num = num;
    if(num <= app.LOCATIONLENGTH){
      //定位距离异常
    //定位距离异常
    const obj = {
      type:"visitIn",
      lat:that.locationObject.a_Latitude,
      lng:that.locationObject.a_Longitude,
      Address:that.locationObject.Address,
      InDeviationNumber:that.locationObject.a_InDeviationNumber || 0,
      isLocationSucess:true
    };
    localStorage.setItem("clockLocation",JSON.stringify(obj));
    localStorage.setItem("visitStoreInfo",JSON.stringify({
      id:parms.ID.value,
      name:parms.name.value,
      address:parms.address.value
    }));
      try{
        that.CloinId(0,1,that.locationObject,_lng,_lat).then(data=>{
          console.log(data);
      }).catch(err=>{
        console.log(err);
      });
      }catch(err){
        console.log(err);
      }
      result=true;
    }else{
      try{
        that.CloinId(0,0,that.locationObject,_lng,_lat,"您的打卡范围超过"+app.LOCATIONLENGTH+"米").then(data=>{
          console.log(data);
      }).catch(err=>{
        console.log(err);
      });
      }catch(err){
        console.log(err);
      }
    }
    return result;
   }
/**
   * 获取门店坐标得方法
   * @param type 考勤类型 0 上班  1 下班
   * @param state 打卡状态 0 失败  1 成功
   * @param obj 
   */
   CloinId(type:number,state:number,obj:any={},long:any=0,lat:any=0,error:any=""): Promise<any>{
    let that = this;
    let msg = new WebResponesContext();
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.ConfigName = "UpdateStoreLongitudeAndLatitude";
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Type = null;
    body.Client.Name = "product";
    body.Client.ClientType = 1;
    let _obj = {};
    _obj["ClockInState"]=state;
    _obj["AttendanceType"]=type;
    _obj["StoreID"] = that.com.GetStorageKey("tbstore")["ID"];
    _obj["StoreLongitude"] =long;
    _obj["StoreLatitude"] = lat;
    _obj["ClockAddress"] = obj.Address;
    _obj["ClockLongitude"] = obj.a_Longitude;
    _obj["ClockLatitude"] = obj.a_Latitude;
    _obj["msg"] = error;
    body.RequestBody = JSON.stringify(_obj);
    return new Promise<any>((resolve, reasole) => {
      that.http.post(app.DEFAULTURL, body).then(data => {
        if (data.ResponseMessage.Success) {
          msg.Status=data.Status;
          resolve(msg);
        } else {
          msg.ResponseMessage.Success=false;
          msg.ResponseMessage.ErrorMessage=data.ResponseMessage.ErrorMessage;
          reasole(msg);
        }
      }).catch(error => {
            msg.ResponseMessage.Success=false;
            msg.ResponseMessage.ErrorMessage="请求数据异常，请联系管理员";
          reasole(msg);
      });
    });

   }
      /**
   * 获取定位信息
   */
  getLocationInfo(): Promise<any>{
    const that = this;
    return new Promise<any>((resolve, reasole)=>{
      if (that.platform.is("cordova")) {
        that.map.getGDCurrentPosition().then(data => {
          that.locationError = false;
          that.locationObject.Address = that.com.GetChineselanage(data.address);
          that.locationObject.a_Latitude = data.latitude;
          that.locationObject.a_Longitude = data.longitude;
          resolve(true);
        }).catch(error => {
          that.locationError = true;
          console.log("定位失败,请联系管理员");
          resolve(false);
        });
      } else {
        that.locationObject.Address = "";
        that.locationObject.a_Latitude = 0;
        that.locationObject.a_Longitude = 0;
        console.log("定位开始");
        that.map.Geolocation(that.map_container.nativeElement).then(data => {
          // loads.dismiss();
          that.locationError = false;
          that.locationObject.Address = that.com.GetChineselanage(data.formattedAddress);
          that.locationObject.a_Latitude = data.position.lat;
          that.locationObject.a_Longitude = data.position.lng;
          resolve(true);
        }).catch(error => {
          console.log(error,"定位失败");
          that.locationError = true;
          reasole(false);
          // loads.dismiss();
        });
      }
    })
  }

  /**
   * 获取定位差距
   */
  getCoordinateDifference(lng,lat){
    const that = this;
    let _num = that.com.Dist(
      that.locationObject.a_Longitude,
      that.locationObject.a_Latitude,
      lng,lat);
      that.locationObject.a_InDeviationNumber = _num;
      console.log(_num.toFixed(2),"_num");
      return _num;
  }

  slideOpts = {
    effect: 'slide',
    speed: 1500,
    loop:true,
    slidesPerView:2,
    direction:"vertical",
    autoplay: {
      delay: 3000
    }
  };
}
